import React, { useEffect } from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { CONTACT } from '../mock';
import Reveal from '../components/Reveal';

const Contact = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const info = [
    { icon: Phone, label: 'Call Us', lines: [CONTACT.phonePrimary, CONTACT.phoneSecondary] },
    { icon: Mail, label: 'Email', lines: [CONTACT.email] },
    { icon: MapPin, label: 'Location', lines: [CONTACT.address] },
  ];

  return (
    <div>
      {/* Banner */}
      <section className="bg-[#0b0b0b] py-20 sm:py-24 text-center">
        <p className="overline text-gold-gradient mb-3">We’d Love To Hear From You</p>
        <h1 className="font-display text-5xl sm:text-7xl text-[#f7f3ec] underline-grow">Get In Touch</h1>
      </section>

      <section className="relative bg-[#0b0b0b] overflow-hidden py-16 sm:py-24">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(198,161,91,0.14),transparent_55%)]" />
        <div className="relative max-w-[1500px] mx-auto px-4 sm:px-6 grid lg:grid-cols-5 gap-12 lg:gap-14 items-start">
          {/* Contact info */}
          <Reveal className="lg:col-span-2">
          <div>
            <h2 className="font-display text-3xl text-[#f7f3ec] mb-3">Let’s talk hair.</h2>
            <p className="font-body text-[#cfc7b8] leading-relaxed mb-9 max-w-md">
              Questions about a product, an order, or a custom unit? Reach out — our team responds within one business day.
            </p>
            <div className="space-y-7">
              {info.map((x) => (
                <div key={x.label} className="flex gap-4">
                  <div className="w-11 h-11 shrink-0 border border-[#c6a15b]/50 flex items-center justify-center">
                    <x.icon size={19} className="text-[#c6a15b]" />
                  </div>
                  <div>
                    <p className="overline text-[0.6rem] text-[#9c9587] mb-1.5">{x.label}</p>
                    {x.lines.map((l) => <p key={l} className="font-body text-sm text-[#e6ddc9] break-words">{l}</p>)}
                  </div>
                </div>
              ))}
            </div>
          </div>
          </Reveal>

          {/* Embedded form */}
          <Reveal className="lg:col-span-3" delay={0.15}>
          <div className="bg-white p-2 sm:p-3 rounded-lg shadow-2xl">
            <iframe
              src="https://nikki-s-next-level-hair-beauty.ninjapipe.app/forms/nnl-website-form?hidePrivacyNotice=1"
              title="NNL Website Form"
              width="100%"
              height="1050"
              frameBorder="0"
              scrolling="no"
              className="w-full rounded-md border-0 block"
              style={{ minHeight: '1050px' }}
            />
          </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Contact;
